var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleIndividual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(-694 -466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(694 466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    fill: "none",
    stroke: "#282d3d",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-target": "stroke",
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 13,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_392",
    "data-name": "Path 392",
    transform: "translate(39.432 109.85)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.569,376.15a8.5,8.5,0,1,0,8.5,8.5A8.5,8.5,0,0,0,691.569,376.15Zm0,21.25c-5.674,0-17,2.848-17,8.5v4.25h34V405.9C708.569,400.248,697.242,397.4,691.569,397.4Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-target": "fill",
    d: "M 691.5689697265625 378.1499938964844 C 687.98486328125 378.1499938964844 685.0689697265625 381.0658874511719 685.0689697265625 384.6499938964844 C 685.0689697265625 388.2341003417969 687.98486328125 391.1499938964844 691.5689697265625 391.1499938964844 C 695.153076171875 391.1499938964844 698.0689697265625 388.2341003417969 698.0689697265625 384.6499938964844 C 698.0689697265625 381.0658874511719 695.153076171875 378.1499938964844 691.5689697265625 378.1499938964844 M 691.5689697265625 399.3999938964844 C 689.1180419921875 399.3999938964844 685.111328125 400.014404296875 681.6849975585938 401.3870544433594 C 680.0185546875 402.0546875 678.6694946289062 402.8396606445312 677.7837524414062 403.6571350097656 C 676.96630859375 404.4115600585938 676.5689697265625 405.1452331542969 676.5689697265625 405.8999938964844 L 676.5689697265625 408.1499938964844 L 706.5689697265625 408.1499938964844 L 706.5689697265625 405.8999938964844 C 706.5689697265625 405.145263671875 706.1715698242188 404.41162109375 705.3540649414062 403.6571960449219 C 704.46826171875 402.8396911621094 703.119140625 402.0546875 701.4525756835938 401.3870544433594 C 698.0261840820312 400.014404296875 694.0196533203125 399.3999938964844 691.5689697265625 399.3999938964844 M 691.5689697265625 376.1499938964844 C 696.2630004882812 376.1499938964844 700.0689697265625 379.9559936523438 700.0689697265625 384.6499938964844 C 700.0689697265625 389.3450012207031 696.2630004882812 393.1499938964844 691.5689697265625 393.1499938964844 C 686.8740234375 393.1499938964844 683.0689697265625 389.3450012207031 683.0689697265625 384.6499938964844 C 683.0689697265625 379.9559936523438 686.8740234375 376.1499938964844 691.5689697265625 376.1499938964844 Z M 691.5689697265625 397.3999938964844 C 697.2420043945312 397.3999938964844 708.5689697265625 400.2479858398438 708.5689697265625 405.8999938964844 L 708.5689697265625 410.1499938964844 L 674.5689697265625 410.1499938964844 L 674.5689697265625 405.8999938964844 C 674.5689697265625 400.2479858398438 685.89501953125 397.3999938964844 691.5689697265625 397.3999938964844 Z",
    stroke: "none",
    fill: "#282d3d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleIndividual);
export default __webpack_public_path__ + "static/media/roleIndividual.65ec57d8.svg";
export { ForwardRef as ReactComponent };